import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from 'react-tooltip';

const ReportLiveData = (props) => {
  const { data = [], title = 'data' } = props;
  return (
    <div className="live-report-details">
      {data.length === 0 ? (
        <div className="no-data">{`No ${title} data available`}</div>
      ) : (
        <React.Fragment>
          <div className="py-1 px-2 fw-bold w-100 d-flex justify-content-between align-items-center fs-5">
            <label>{`Numbers ${title}`}</label>
            <label>{data.length}</label>
          </div>
          <div className="live-report-table-wrapper">
            <table>
              <thead>
                <tr>
                  <th>Phone No.</th>
                  <th className="text-end">Duration</th>
                </tr>
              </thead>
              <tbody>
                {data?.map((val, index) => {
                  return (
                    <tr key={index}>
                      <td>
                        <span
                          id={`tooltip-anchor-${index}`}
                          data-tooltip-id={`tooltip-${index}`}
                          className="cursor-pointer">
                          {val.phone_number}
                        </span>
                        <Tooltip id={`tooltip-${index}`} place="top" content={val.process_name} />
                      </td>
                      <td className="text-end">{val.time_difference}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </React.Fragment>
      )}
    </div>
  );
};

ReportLiveData.propTypes = {
  data: PropTypes.array,
  title: PropTypes.string
};

export default ReportLiveData;
